<ng-template #statWidgets>
  <div class="stat-content w-100">

    <ng-template #loadingBlock>
      <div class="d-flex justify-content-center mt-4">
        <p class="fw-medium text-muted text-center mb-4"><i>Loading...</i></p>
      </div>
    </ng-template>

    <ng-template #noDataBlock>
      <div class="d-flex justify-content-center mt-4">
        <p class="fw-medium text-muted text-center mb-4"><i>No available data</i></p>
      </div>
    </ng-template>

    <div class="row g-3 justify-content-center" [ngClass]="rowColsClass">

      <div class="col" [class.d-none]="isOtherClass">

        @if(isChartLoading(chartTitles.devicesByCarrier)) {
          <ng-container *ngTemplateOutlet="loadingBlock"></ng-container>
        } @else if(devicesByCarrierChart) {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Device Carriers
              </strong>
            </div>
          </div>

          <div class="card-body w-100">
            <apx-chart
              [chart]="devicesByCarrierChart.chart"
              class="apex-charts"
              [colors]="devicesByCarrierChart.colors"
              [dataLabels]="devicesByCarrierChart.dataLabels"
              [height]="maxChartHeight"
              [labels]="devicesByCarrierChart.labels"
              [legend]="devicesByCarrierChart.legend"
              [series]="devicesByCarrierChart.series"
              [stroke]="devicesByCarrierChart.stroke"
              [tooltip]="devicesByCarrierChart.tooltip"
              [width]="'100%'"
            ></apx-chart>
            <div class="ss-legend">
              <div class="ss-legend-item"
                   *ngFor="let item of devicesByCarrierChart.legendItems; let i = index"
                   (mouseenter)="chartConfigService.onLegendEnter(devicesByCarrierChart, i)"
                   (mouseleave)="chartConfigService.onLegendLeave(devicesByCarrierChart)"
                   (click)="onLegendClick(devicesByCarrierChart, item.rawLabel)"
              >
                   
                <span class="ss-legend-dot" [style.background]="item.color"></span>
                <span class="ss-legend-text">{{item.label}}</span>
              </div>
            </div>
          </div>
        } @else {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Device Carriers
              </strong>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="noDataBlock"></ng-container>
        }
      </div>

      <div class="col">

        @if(isChartLoading(chartTitles.devicesByCompanyManaged)) {
          <ng-container *ngTemplateOutlet="loadingBlock"></ng-container>
        } @else if(devicesByCompanyManagedChart) {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Devices Managed By
              </strong>
            </div>
          </div>

          <div class="card-body w-100">
            <apx-chart
              [chart]="devicesByCompanyManagedChart.chart"
              class="apex-charts"
              [colors]="devicesByCompanyManagedChart.colors"
              [dataLabels]="devicesByCompanyManagedChart.dataLabels"
              [height]="maxChartHeight"
              [labels]="devicesByCompanyManagedChart.labels"
              [legend]="devicesByCompanyManagedChart.legend"
              [series]="devicesByCompanyManagedChart.series"
              [stroke]="devicesByCompanyManagedChart.stroke"
              [tooltip]="devicesByCompanyManagedChart.tooltip"
              [width]="'100%'"
            ></apx-chart>
            <div class="ss-legend">
              <div class="ss-legend-item"
                   *ngFor="let item of devicesByCompanyManagedChart.legendItems; let i = index"
                   (mouseenter)="chartConfigService.onLegendEnter(devicesByCompanyManagedChart, i)"
                   (mouseleave)="chartConfigService.onLegendLeave(devicesByCompanyManagedChart)"
                   (click)="onLegendClick(devicesByCompanyManagedChart, item.rawLabel)"
              >
                   
                <span class="ss-legend-dot" [style.background]="item.color"></span>
                <span class="ss-legend-text">{{item.label}}</span>
              </div>
            </div>
          </div>
        } @else {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Devices Managed By
              </strong>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="noDataBlock"></ng-container>
        }
      </div>

      <div class="col" [class.d-none]="isOtherClass">

        @if(isChartLoading(chartTitles.devicesBySupervised)) {
          <ng-container *ngTemplateOutlet="loadingBlock"></ng-container>
        } @else if(devicesBySupervisedChart) {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Supervised Devices
              </strong>
            </div>
          </div>

          <div class="card-body w-100">
            <apx-chart
              [chart]="devicesBySupervisedChart.chart"
              class="apex-charts"
              [colors]="devicesBySupervisedChart.colors"
              [dataLabels]="devicesBySupervisedChart.dataLabels"
              [height]="maxChartHeight"
              [labels]="devicesBySupervisedChart.labels"
              [legend]="devicesBySupervisedChart.legend"
              [series]="devicesBySupervisedChart.series"
              [stroke]="devicesBySupervisedChart.stroke"
              [tooltip]="devicesBySupervisedChart.tooltip"
              [width]="'100%'"
            ></apx-chart>
            <div class="ss-legend">
              <div class="ss-legend-item"
                   *ngFor="let item of devicesBySupervisedChart.legendItems; let i = index"
                   (mouseenter)="chartConfigService.onLegendEnter(devicesBySupervisedChart, i)"
                   (mouseleave)="chartConfigService.onLegendLeave(devicesBySupervisedChart)"
                   (click)="onLegendClick(devicesBySupervisedChart, item.rawLabel)"
              >
                   
                <span class="ss-legend-dot" [style.background]="item.color"></span>
                <span class="ss-legend-text">{{item.label}}</span>
              </div>
            </div>
          </div>
        } @else {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Supervised Devices
              </strong>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="noDataBlock"></ng-container>
        }
      </div>

      <div class="col">

        @if(isChartLoading(chartTitles.devicesByEncrypted)) {
          <ng-container *ngTemplateOutlet="loadingBlock"></ng-container>
        } @else if(devicesByEncryptedChart) {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Encrypted Devices
              </strong>
            </div>
          </div>

          <div class="card-body w-100">
            <apx-chart
              [chart]="devicesByEncryptedChart.chart"
              class="apex-charts"
              [colors]="devicesByEncryptedChart.colors"
              [dataLabels]="devicesByEncryptedChart.dataLabels"
              [height]="maxChartHeight"
              [labels]="devicesByEncryptedChart.labels"
              [legend]="devicesByEncryptedChart.legend"
              [series]="devicesByEncryptedChart.series"
              [stroke]="devicesByEncryptedChart.stroke"
              [tooltip]="devicesByEncryptedChart.tooltip"
              [width]="'100%'"
            ></apx-chart>
            <div class="ss-legend">
              <div class="ss-legend-item"
                   *ngFor="let item of devicesByEncryptedChart.legendItems; let i = index"
                   (mouseenter)="chartConfigService.onLegendEnter(devicesByEncryptedChart, i)"
                   (mouseleave)="chartConfigService.onLegendLeave(devicesByEncryptedChart)"
                   (click)="onLegendClick(devicesByEncryptedChart, item.rawLabel)"
              >
                   
                <span class="ss-legend-dot" [style.background]="item.color"></span>
                <span class="ss-legend-text">{{item.label}}</span>
              </div>
            </div>
          </div>
        } @else {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Encrypted Devices
              </strong>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="noDataBlock"></ng-container>
        }
      </div>

      <div class="col" [class.d-none]="isOtherClass">

        @if(isChartLoading(chartTitles.devicesByJailbroken)) {
          <ng-container *ngTemplateOutlet="loadingBlock"></ng-container>
        } @else if(devicesByJailbrokenChart) {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Jailbroken Devices
              </strong>
            </div>
          </div>

          <div class="card-body w-100">
            <apx-chart
              [chart]="devicesByJailbrokenChart.chart"
              class="apex-charts"
              [colors]="devicesByJailbrokenChart.colors"
              [dataLabels]="devicesByJailbrokenChart.dataLabels"
              [height]="maxChartHeight"
              [labels]="devicesByJailbrokenChart.labels"
              [legend]="devicesByJailbrokenChart.legend"
              [series]="devicesByJailbrokenChart.series"
              [stroke]="devicesByJailbrokenChart.stroke"
              [tooltip]="devicesByJailbrokenChart.tooltip"
              [width]="'100%'"
            ></apx-chart>
            <div class="ss-legend">
              <div class="ss-legend-item"
                   *ngFor="let item of devicesByJailbrokenChart.legendItems; let i = index"
                   (mouseenter)="chartConfigService.onLegendEnter(devicesByJailbrokenChart, i)"
                   (mouseleave)="chartConfigService.onLegendLeave(devicesByJailbrokenChart)"
                   (click)="onLegendClick(devicesByJailbrokenChart, item.rawLabel)"
              >
                   
                <span class="ss-legend-dot" [style.background]="item.color"></span>
                <span class="ss-legend-text">{{item.label}}</span>
              </div>
            </div>
          </div>
        } @else {
          <div class="d-flex align-items-center mt-2">
            <div class="flex-grow-1 text-center">
              <strong class="text-primary">
                Jailbroken Devices
              </strong>
            </div>
          </div>
          <ng-container *ngTemplateOutlet="noDataBlock"></ng-container>
        }
      </div>

    </div>
  </div>
</ng-template>

@if (useContainer) {
  @if (visibleContainer) {
    <div class="row" [ngClass]="marginBottom">
      <div class="col-12">
        <div class="border border-success rounded">
          <div class="row">
            <div class="col-12">
              <div
                class="alert border-0 alert-primary d-flex justify-content-between align-items-center mb-0"
                role="alert"
              >
                <div class="d-flex align-items-center" style="gap: 8px;">
                  <strong>{{containerTitle}}</strong>
                  <span *ngIf="previousSync && syncInfoText" class="text-muted" style="font-size: 0.85em;">- {{syncInfoText}}</span>
                </div>

                <div class="d-flex align-items-center" style="gap: 6px;">
                  @if (userDomains) {
                    <span class="badge bg-success-subtle text-success fs-11 d-inline-flex align-items-center gap-1">
                      <i class="ri-filter-3-line"></i>
                      Filtered to {{ userDomainsText }}
                      <button class="btn btn-link btn-sm p-0 ms-1 text-primary lh-1" title="Clear the user domain filter" type="button" (click)="userDomainsClear.emit()"><i class="ri-close-line"></i></button>
                    </span>
                  }
                  <button *ngIf="actionButton0Show"
                    type="button"
                    class="btn btn-sm btn-outline-primary rounded-pill"
                    (click)="actionButton0OnClick()"
                  >
                    {{actionButton0Text}}
                  </button>
                  
                  <span
                    *ngIf="!expandContainer && showTitleHintText"
                    class="text-muted"
                    style="font-size: 0.85em;"
                  >
                    Widget Row
                  </span>
                  <i class="fs-5"
                     [attr.data-bs-toggle]="'tooltip'"
                     [attr.data-bs-title]="expandContainer ? 'Collapse' : 'Expand'"
                     [ngClass]="expandContainer ? 'bx bx-up-arrow' : 'bx bx-down-arrow'"
                     style="cursor: pointer; color: #198754;"
                     (click)="toggleContainerExpansion()">
                  </i>
                  <i *ngIf="allowContainerClose"
                     class="fs-3 bx bx-x"
                     [attr.data-bs-toggle]="'tooltip'"
                     data-bs-title="Close"
                     style="cursor: pointer; color: #dc3545;"
                     (click)="closeContainer()">
                  </i>
                </div>
              </div>
            </div>
          </div>
  
          @if (expandContainer) {
            <div class="row mb-1">
              <div class="col-12">
                <div class="w-100">
                  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
} @else {
  <ng-container *ngTemplateOutlet="statWidgets"></ng-container>
}
